import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  ${Mixins.Flex.set('flex-start', 'stretch', 'column')}
`;

export const Image = styled(DynamicImage)`
  object-fit: cover;
  height: 100%;
  width: 100%;
  max-width: 100%;
`;

export const DarkenContainer = styled.div<{ isDeleteMode?: boolean }>`
  background: ${Colors.WHITE};
  transition: all ${Transition.Time.BASE};

  ${ifProp(
    'isDeleteMode',
    css`
      filter: brightness(60%) blur(0.8px);
      pointer-events: none;
    `
  )}
`;

export const ImageContainer = styled(DarkenContainer)`
  display: flex;
  overflow: hidden;
  ${Mixins.Border.setTopSide(Border.Radius.S)}
`;

export const ContentContainer = styled(DarkenContainer)<{ noFooter?: boolean; noHeader?: boolean; noImage?: boolean }>`
  padding: ${Spacing.SINGLE};

  ${ifProp(
    'noHeader',
    css`
      padding-top: 0;
    `
  )}

  ${ifProp(
    'noImage',
    css`
      ${Mixins.Border.setTopSide(Border.Radius.S)}
    `
  )}
  ${ifProp(
    'noFooter',
    css`
      ${Mixins.Border.setBottomSide(Border.Radius.S)}
    `
  )}
`;

export const FooterContainer = styled.div`
  ${Mixins.Border.setBottomSide(Border.Radius.S)}
`;

export const PreviewText = styled.div`
  color: ${Colors.GRAY_DARK_20};
  display: flex;
  justify-content: center;
  margin: ${Spacing.SINGLE} 0;
  text-align: center;
  padding: 0 ${Spacing.DOUBLE};
  white-space: pre-wrap;

  ${Font.bySize(Font.Size.S)}
`;
